import { Component } from '@angular/core';
import { TraceLog } from '../../models/error-log.model';
import { ErrorLogService } from '../error-log/error-log.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { PageEvent } from '@angular/material/paginator';
import { CommentDialogComponent } from '../../shared/components/comment-dialog/comment-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { PageKey } from '../../const';
import { SearchService } from '../common/search.service';

@Component({
  selector: 'app-trace-report',
  templateUrl: './trace-report.component.html',
  styleUrl: './trace-report.component.scss'
})
export class TraceReportComponent {
  traceReportLogs: TraceLog[] = [];
  isEditUser: boolean = false;
  pageSize: number = 10;
  pageNumber: number = 0;
  pageOffSet: number = 0;
  totalRecords: number | undefined;
  searchTerm: string = "";
  pageKey = PageKey.TraceReportCenter;
  sortNameAsc: boolean = true;
  sortReportNameAsc: boolean = true;
  sortColumn: string = "";
  sortDirection: string = "";
  searchBy: string = "Search by Username / Report Name";

  constructor(private errorLogService: ErrorLogService,
              private toasterService: ToastrService,
              public dialog: MatDialog,
              private readonly searchService: SearchService
  ) { }


  ngOnInit(): void {
    this.searchTerm = this.searchService.getSearchTerm(this.pageKey);
    this.getAllLogs();
  }

  changePage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex;
    this.pageOffSet = this.pageNumber * this.pageSize;
    this.getAllLogs();
  }

  viewExceptionModal(description: string) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: description
    });
  }

  getAllLogs(sortColumn = "", sortDirection = "") {
    this.searchService.setSearchTerm(this.pageKey, this.searchTerm);
    if(sortColumn){
      this.sortColumn = sortColumn;
      this.sortDirection = sortDirection;
    }
    let payload: any = {};
    payload.sortColumn = this.sortColumn.charAt(0).toUpperCase() + this.sortColumn.slice(1);
    payload.sortDirection = this.sortDirection;
    payload.pageOffset = this.pageOffSet;
    payload.pageSize = this.pageSize;
    payload.searchTerm = this.searchTerm ? this.searchTerm.trim() : "";
    this.errorLogService.getTraceLogs(payload).subscribe((response: any) => {
      this.totalRecords = response.length ? parseInt(response[0].totalRecords) : 0;
      this.traceReportLogs = response;
    }, (err: HttpErrorResponse) => {
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }
}
